import { InnerBox } from "view-layer/components/layout/InnerBox";

export const Body = (props: { children: React.ReactNode }): JSX.Element =>
  <main>
    <InnerBox pb={8}>
      {props.children}
    </InnerBox>
  </main>;
